import React, { useEffect, useState } from 'react'
import QRCode from "react-qr-code";
import BarcodeReader from "react-barcode-reader";
import TextAreaField from "../../library/components/textarea";
import tick from "../../dashboardicon/tick.svg"
import LeftMenu from '../AnalyticsModule/Left';

const TestQrScanner = () => {
    const dummyScanChar = "A B C D E F G H I J K L M N O P Q R S T U V W X Y Z # 0 1 2 3 4 5 6 7 8 9 . abcdefghijklmnopqrstuvwxyz - _ @ $ , :"
    const [missingChar,setmissingChar]= useState(null)
    const [scanData , setScanData] = useState("")

    const handleScan = (data) => {
        console.log(scanData)
          setScanData(data);
      };

    function second(str1,str2) {
        // return Array.prototype.filter.call(str1, function(c) {
        //     return str2.indexOf(c) === -1;
        // }, this).join('');
        if (str1.length !== str2.length) {
          return "No";
        }
        // Compare each character one by one
        for (let i = 0; i < str1.length; i++) {
          if (str1[i] !== str2[i]) {
            return "No"
          }
        }
        // If all characters match exactly
        return "";
    }


    useEffect(()=>{
        if(scanData!=""){
          setmissingChar(second(dummyScanChar, scanData))
        }
      },[scanData])

      const handleChange = (key, value) => {
        // setData((prevState) => ({
        //   ...prevState,
        //   [key]: value,
        // }));
      };

      const handleError = (err) => {
        console.error(err);
      };
    

    return (
    <LeftMenu>
    <div className='container box my-4'>
    <BarcodeReader onError={handleError} onScan={handleScan} />
    <p style={{
     fontSize: "17px",
     color: "red",
     fontWeight: "500",
     fontFamily: "auto",
    }}>Kindly scan this Qr code with scanner and make sure all alphabets(A - Z), Numbers(0 - 9) and Special Characters( # ) are scannable. i.e-   A B C D E F G H I J K L M N O P Q R S T U V W X Y Z # 0 1 2 3 4 5 6 7 8 9 . abcdefghijklmnopqrstuvwxyz - _ @ $ , : </p>
    <div style={{ height: "auto", margin: "0 auto", maxWidth: "100Px", width: "100%" }}>
   <QRCode
   size={350}
   style={{ height: "auto", maxWidth: "100%", width: "100%" }}
   value={dummyScanChar}
   viewBox={`0 0 350 350`}
   />
  
</div>
<div className="col-md-12 my-4 d-flex" >
   <TextAreaField
   inputClass={"col-md-12"}
   labelClass={"col-md-12"}
   readonly={true}
             type="textrea"
             name="remarks"
             placeholder=""
             rows="4"
             cols="400"
             maxLength="250"
             value={scanData}
             onChange={(val) => handleChange("remarks", val)}
           ></TextAreaField>
         {missingChar === "" &&   <img className="ballotcheckOk" src={tick} />}
   </div>
   {(missingChar !=null && missingChar !=="") && <div className="col-md-12 my-4 ">
     <h6 style={{ color:"red", textAlign:"center"}}> The QR Code scanner is not compatible. Please try to reset the QR Code Scanner to factory mode and manual trigger mode and re-check its compatibility, else replace the QR Code Scanner.</h6>
   </div>}
    </div>
    </LeftMenu>
  )
}

export default TestQrScanner